module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/array/from.js
// module id = 461
// module chunks = 52252321336229